import { Component } from '@angular/core';

@Component({
  selector: 'app-marketing-resources',
  templateUrl: './marketing-resources.component.html'
})
export class MarketingResourcesComponent { }
